import { useEffect, useMemo, useRef, useState } from "react";
import { useConfigStore } from "../../../../../stores/ConfigStore";
import { useLanguage } from "../../../../../stores/LanguageStore";
import {
  ActionIcon,
  Badge,
  Button,
  Divider,
  Group,
  Image,
  Loader,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import TextEditor from "../../../../../components/ExternalEditors/TextEditor";
import BackButton from "../../../../../components/View/BackButton";
import {
  IconFilePlus,
  IconPaperclip,
  IconSend,
  IconX,
} from "@tabler/icons-react";
import FilesModal from "../../../files/FilesModal";
import AddTokens from "../../../../../components/Adder/AddTokens";
import { FileUploader } from "react-drag-drop-files";
import fileSvg from "../../../lists/import/manualImport/FileIllustration.svg";
import ReplyGenerator from "../../../models/emails/ReplyGenerator";
import {
  getPermission,
  insertTextToInput,
} from "../../../../../functions/utilFunctions";
import EmailModalPreview from "../../../../../components/View/EmailModalPreview";
import ModelTemplateSender from "../../../models/ModelTemplateSender";

const EmailAnswerEditorMobile = ({
  id,
  handleClose,
  handleSubmit,
  onInit,
  loading,
  disabled,
  sign,
  defaultSubject,
}) => {
  const lang = useLanguage((s) => s.language);
  const editorRef = useRef();

  const datafields = useConfigStore((s) => s.datafields);
  const datafieldTokens = useMemo(() => {
    let df = datafields.map((x) => ({
      label: x.name,
      value: x.identifier_placeholder,
    }));

    df = [
      {
        label: lang.components.variable_manager.dialog.signature_variable_name,
        value: "%signature%",
        name: lang.components.variable_manager.dialog.signature_variable_name,
      },
      {
        label:
          lang.components.variable_manager.dialog.unsubscribe_variable_name,
        value: "%unsubscribe%",
        name: lang.components.variable_manager.dialog.unsubscribe_variable_name,
      },
      {
        label: lang.components.variable_manager.dialog.webversion_variable_name,
        value: "%webversion%",
        name: lang.components.variable_manager.dialog.webversion_variable_name,
      },
      
      ...df,{
        label: lang.components.variable_manager.dialog.b64_variable_name,
        value: "%email_b64%",
        name: lang.components.variable_manager.dialog.b64_variable_name,
      },
    ];

    return df;
  }, [datafields, lang]);

  const [dragging, setDragging] = useState(false);
  const [files, setFiles] = useState([]);

  const handleFileRemove = (file) => {
    setFiles((prev) =>
      prev.filter((x) => x.lastModified !== file.lastModified)
    );
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    let html = "";
    let text = "";

    html = editorRef?.current?.getContent();
    text = editorRef?.current?.getContent({ format: "text" });

    return handleSubmit({
      html,
      text,
      subject: data.subject,
      files,
    });
  };

  const onEmailGenerated = (html) => {
    editorRef.current?.setContent(html);
  };

  const onModelImport = (model) => {
    editorRef.current?.setContent(model?.html);

    if (model?.subject) {
      document.getElementById("email-subject-sender").value = model.subject;
    }
  };

  useEffect(() => {
    if (sign && editorRef.current) {
      // let html = editorRef.current.getContent();

      // if (!html) {
      //   editorRef.current.execCommand(
      //     "mceInsertContent",
      //     false,
      //     "<br /> %signature%"
      //   );
      // }
      const currentContent = editorRef.current.getContent(); // Get current HTML
      const newContent = currentContent.includes("%signature%")
        ? currentContent
        : currentContent + "<br /> %signature%"; // Append at the end
      editorRef.current.setContent(newContent); // Set new content
    }
  }, [sign, editorRef]);

  return (
    <Stack
      component={"form"}
      onSubmit={onSubmit}
      gap={0}
      id="model-form"
      w={"100%"}
      pos={"relative"}
      h={"63vh"}
      onDragOver={(e) => {
        e.dataTransfer ? setDragging(true) : setDragging(false);
      }}
    >
      <TextInput
        id="email-subject-sender"
        placeholder={`${lang.model_emails.create.dialog.subject} *`}
        size="sm"
        name="subject"
        variant="unstyled"
        defaultValue={defaultSubject}
        styles={{ input: { border: 0 } }}
        required
        radius={"md"}
        rightSection={
          loading ? (
            <Loader type="dots" size={16} />
          ) : (
            <AddTokens
              position="bottom-end"
              buttonProps={{ size: 24 }}
              items={datafieldTokens}
              handleAdd={(item) => {
                let input = document.getElementById("email-subject-sender");
                insertTextToInput(
                  `{${item?.value.replaceAll("%", "")}}`,
                  input
                );
              }}
            />
          )
        }
      />

      <Divider opacity={0.5} mt={4} />

      <TextEditor
        id={id}
        editorRef={editorRef}
        placeholder={"Répondre ici..."}
        tokens={datafieldTokens}
        isMobile
        toolbar="bold italic underline numlist bullist link"
        // noTop
        autoFocus
        disableDecor
        onInit={onInit}
        // initialValue={sign ? "<br /><br /> %signature%" : ""}
      >
        <Group
          wrap="nowrap"
          style={{
            position: "absolute",
            top: 5,
            right: 4,
            zIndex: 4,
            overflow: "hidden",
          }}
        >
          {/* <FilesModal editorRef={editorRef} /> */}

          <FileUploader handleChange={(f) => setFiles((prev) => [...prev, f])}>
            <ActionIcon size="lg" variant="light">
              <IconPaperclip size={18} />
            </ActionIcon>
          </FileUploader>

          {/* {getPermission("suggestedAnswerAi") && (
            <ReplyGenerator replyId={id} onFinish={onEmailGenerated} />
          )} */}
        </Group>
      </TextEditor>

      <Divider opacity={0.5} />

      {/* {files.length > 0 && (
        <>
          <Group py={8} px={8}>
            {files.map((file) => (
              <Badge
                key={file.lastModified}
                variant="light"
                rightSection={
                  <ActionIcon
                    variant="subtle"
                    size={"sm"}
                    onClick={() => handleFileRemove(file)}
                  >
                    <IconX />
                  </ActionIcon>
                }
                size="xl"
                tt={"none"}
                radius={"sm"}
              >
                {file.name}{" "}
                <Text span c={"black"}>
                  ({(file.size / 1024).toFixed(0)}Ko)
                </Text>
              </Badge>
            ))}
          </Group>
          <Divider opacity={0.5} />
        </>
      )} */}

      <Stack pt={16} gap={0}>
        <Group>
          {files.length > 0 && (
            <>
              <Group py={8}>
                {files.map((file) => (
                  <Badge
                    key={file.lastModified}
                    variant="light"
                    rightSection={
                      <ActionIcon
                        variant="subtle"
                        size={"xs"}
                        onClick={() => handleFileRemove(file)}
                      >
                        <IconX />
                      </ActionIcon>
                    }
                    size="lg"
                    tt={"none"}
                    radius={"sm"}
                  >
                    {file.name}{" "}
                    <Text span c={"black"} size="xs">
                      ({(file.size / 1024).toFixed(0)}Ko)
                    </Text>
                  </Badge>
                ))}
              </Group>
              <Divider opacity={0.5} />
            </>
          )}
        </Group>

        <Group>
          <BackButton
            onClick={handleClose}
            label={lang.global.cancel}
            size="md"
            ml="auto"
          />

          <Button
            type="submit"
            rightSection={<IconSend size={18} />}
            size="md"
            loading={loading}
            disabled={disabled}
          >
            {lang.global.send}
          </Button>
        </Group>
      </Stack>
    </Stack>
  );
};

export default EmailAnswerEditorMobile;
